import React from 'react'
import { Spin } from 'antd'
import './PageLoader.less'

const PageLoader = () => {
    return (
        <div className="page-loader">
            <Spin size="large" description="Caricamento..." />
        </div>
    )
}

export default PageLoader